import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import * as paths from 'app-router/paths';
import { useStore } from 'stores';
import { PagedRequesters, Requester } from 'stores/RequesterStore';
import { ActionIcon, DeleteIcon, EditIcon } from 'components/Icon';
import { SimpleInlineHelp } from 'components/InlineHelp';

interface Props
{
  requesters: PagedRequesters,
  editRequesterHandler: (feature: Requester) => Promise<void>,
  deleteRequesterHandler: (feature: Requester) => Promise<void>,
}
export const RequesterList: React.FC<Props> = observer(({requesters, editRequesterHandler, deleteRequesterHandler}: Props) =>
{
  const { uiStore } = useStore();

  return (
    <table>
      <thead>
        <tr>
          <th>{uiStore.labels.pages.audience.requestersTable.tokenColumnName}</th>
          <th>{uiStore.labels.pages.audience.requestersTable.nameColumnName}</th>
          <th>
            {uiStore.labels.pages.audience.requestersTable.pathColumnName}
            <SimpleInlineHelp>{uiStore.labels.help.audience.requesters.path.about}</SimpleInlineHelp>
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {
          requesters.data?.map(x =>
            <tr key={x.token}>
              <td>
                <Link title={uiStore.labels.pages.audience.viewDetailsOfRequester.apply({requesterName: x.name})}
                      to={{pathname: paths.buildRequesterViewPath(x.token || ''), state: { isCancelRequired: true }}}>
                  {x.token}
                </Link>
              </td>
              <td>{x.name}</td>
              <td>{x.path}</td>
              <td className="actions">
                <ActionIcon tip={uiStore.labels.pages.audience.editRequester.apply({requesterName: x.name})} action={async () => await editRequesterHandler(x)}><EditIcon /></ActionIcon>
                <ActionIcon tip={uiStore.labels.pages.audience.deleteRequester.apply({requesterName: x.name})} action={async () => await deleteRequesterHandler(x)}><DeleteIcon /></ActionIcon>
              </td>
            </tr>)
        }
      </tbody>
    </table>
  );
});